import React from 'react';
import {  Typography } from 'antd'
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Import the CSS for styling

import { getData } from '../apiUtils';
import { isExternal, startTime } from '../workshopUtils';


const localizer = momentLocalizer(moment) // or globalizeLocalizer


// Outreach talks and lectures that have no page in the CMS. Workshops are no
// longer listed here — they come from Strapi automatically (see cmsEvents
// below), so adding a workshop there puts it on this calendar with no code
// change.
const manualEvents = [

	 {
    title: "Probing the Sun with India\'s First Solar Space Mission: Aditya-L1",
    start: new Date(2023, 9, 10, 16, 0), // Date and time when the event starts
    end: new Date (2023, 9, 10, 18, 0),   // Date and time when the event ends

     },

 	 {
    title: "India\'s first Space based Solar Mission Aditya-L1",
    start: new Date(2023, 9, 9, 14, 0), // Date and time when the event starts
    end: new Date (2023, 9, 9, 16, 0),   // Date and time when the event ends

 	 },

	  {
    title: 'Our Sun with Aditya-L1',
    start: new Date(2023, 9, 9, 10, 0), // Date and time when the event starts
    end: new Date (2023, 9, 9, 12, 0),   // Date and time when the event ends
 	 },

    {
      title: 'Aditya-L1 Support Cell Fifth Workshop at IIT Kanpur',
      start: new Date(2023, 8, 29, 9, 0), // Date and time when the event starts
      end: new Date (2023, 9, 1, 18, 0),   // Date and time when the event ends
      url:'https://al1ssc.aries.res.in/workshop-5',

    },

    {
      title: 'Technical Talk on Solar Data Analysis using AI/ML based Techniques at IIT BHU',
      start: new Date(2023, 8, 27, 11, 0),
      end: new Date (2023, 8, 27, 17, 0),
    },

    {
      title: 'Popular Talk on Aditya-L1 Mission- A journey towards the sun at Birla Industrial and Technological Museums',
      start: new Date(2023, 8, 6, 11, 0),
      end: new Date (2023, 8, 6, 15, 0),
    },

    {
      title: 'India \'s own Aditya L1 Mission at Nehru Planetarium Prime Minister Museum & Library ',
      start: new Date(2023, 8, 4, 9, 0),
      end: new Date (2023, 8, 4, 13, 0),
    },

    {
      title: 'Aditya L1 Mission Talk at Tamil Nadu Science and Technology Centre, Ariviyal Palagai ',
      start: new Date(2023, 8, 3, 11, 0),
      end: new Date (2023, 8, 3, 15, 0),
    },

    {
      title: 'Aditya-L1 Support Cell Fourth Workshop at ARIES Nainital',
      start: new Date(2023, 5, 28, 9, 0), // Date and time when the event starts
      end: new Date (2023, 6, 7, 18, 0),   // Date and time when the event ends
      url:'https://al1ssc.aries.res.in/workshop-4',

    },

    {
      title: 'A Public lecture on Probing our Nearest Star through Aditya-L1 Mission ',
      start: new Date(2023, 2, 15, 17, 0),
      end: new Date (2023, 2, 15, 21, 0),
    },

    {
      title: 'Aditya-L1 Support Cell Third Workshop at IIT BHU',
      start: new Date(2023, 1, 25, 9, 0), // Date and time when the event starts
      end: new Date (2023, 1, 27, 18, 0),   // Date and time when the event ends
      url:'https://al1ssc.aries.res.in/workshop-3',

    },
    {
      title: 'Aditya-L1 Support Cell Second Workshop at MAHE, Manipal',
      start: new Date(2022, 10, 27, 9, 0), // Date and time when the event starts
      end: new Date (2022, 10, 30, 18, 0),   // Date and time when the event ends
      url:'https://al1ssc.aries.res.in/workshop-2',

    },
    {
      title: 'Aditya-L1 Support Cell First Workshop at ARIES, Nainital',
      start: new Date(2022, 5, 27, 9, 0), // Date and time when the event starts
      end: new Date (2022, 6, 6, 18, 0),   // Date and time when the event ends
      url:'https://al1ssc.aries.res.in/workshop-1',

    },

  ];

// Absolute and relative links to the same workshop must compare equal, so the
// hand-written entries above get replaced rather than duplicated once the same
// workshop carries dates in Strapi.
const urlPath = (url = '') => {
  try {
    return new URL(url, 'https://al1ssc.aries.res.in').pathname.replace(/\/$/, '');
  } catch (e) {
    return url;
  }
};

const EventCalendar = () => {

  const Title = Typography;
  const history = useHistory();

  // Same cache key as the header, so this is free when navigating from the menu.
  const { data } = useQuery('workshop_menu', getData({ apiRoute: '/workshop-menu' }));

  const handleEventClick = (event) => {
    if (!event.url) return;
    if (isExternal(event.url)) {
      window.open(event.url, '_blank'); // Open the link in a new tab
    } else {
      history.push(event.url);
    }
  };

  const workshops = (data && data.menu && data.menu.workshop_pages) || [];

  // Anything in the CMS carrying a start date becomes a calendar entry.
  const cmsEvents = workshops
    .filter((item) => startTime(item) !== null)
    .map((item) => ({
      title: item.title,
      start: new Date(item.startDate),
      end: new Date(item.endDate || item.startDate),
      url: item.url,
      fromCms: true,
    }));

  const cmsPaths = new Set(cmsEvents.map((e) => urlPath(e.url)));

  const events = [
    ...cmsEvents,
    ...manualEvents.filter((e) => !e.url || !cmsPaths.has(urlPath(e.url))),
  ];

  // Open on the next upcoming event when there is one, otherwise on the most
  // recent. Without this the calendar lands on today and looks empty.
  const now = Date.now();
  const future = events.filter((e) => e.end.getTime() >= now)
    .sort((a, b) => a.start - b.start);
  const past = events.slice().sort((a, b) => b.start - a.start);
  const defaultDate = (future[0] || past[0] || {}).start || new Date();

  const eventPropGetter = (event) => ({
    style: event.end.getTime() >= now
      ? { backgroundColor: '#ff4d4f' }  // upcoming
      : { backgroundColor: '#1890ff' }, // past — matches site primary
  });

  return (
    <div>

    <Title style={ {  textAlign: 'center', margin:'10px 0' }} ><h4>Aditya L1 Events Calendar</h4></Title>
    <p>For event addition, related to Aditya-L1. Please fill out this <a href="https://forms.gle/dvfa4DiUahBwgJJb7" target="_blank
    ">form </a></p>
    <Calendar
      localizer={localizer}
      events={events}
      defaultDate={defaultDate}
      startAccessor="start"
      endAccessor="end"
      onSelectEvent={handleEventClick} // Handle event click
      eventPropGetter={eventPropGetter}
      style={{  height: '600px', }} // Set the calendar height
    />

    </div>

  )
}

export default EventCalendar
